import { Injectable } from '@angular/core';
import { RestService } from 'app/core/services/rest/rest.service';
import { FilterValuesTO } from 'app/core/interfaces/filtervalues.interface';
import { Observable } from 'rxjs';
import { util } from '../../util/util';

@Injectable({ providedIn: 'root' })
export class FilterValuesRestService {
  constructor(private restService: RestService) {}

  getOrderFilterValues(selectedCustomerId: string, customerIds: string[]): Observable<FilterValuesTO> {
    return this.getFilterValues('Order', selectedCustomerId, customerIds);
  }

  getFlowFilterValues(selectedCustomerId: string, customerIds: string[]): Observable<FilterValuesTO> {
    return this.getFilterValues('Flow', selectedCustomerId, customerIds);
  }

  private getFilterValues(type: string, selectedCustomerId: string, customerIds: string[]): Observable<FilterValuesTO>{
    const body = {
      customerId: customerIds || [],
    };
    return this.restService.post<any>(`/${type}/getFilterValues`, body, selectedCustomerId);
  }

}
